import { Arr } from '@deqo/foundation';
import React, { useCallback, useContext, useEffect, useRef } from 'react';
import Scrollbars, { positionValues } from 'react-custom-scrollbars';
import { LFC } from '../../Legacy';

const XScrollbars = Scrollbars as any;
type ScrollingCallback = (data: positionValues) => void;

const ScrollingContext = React.createContext<ScrollingCallback[]>([]);

export const useScrollingCallback = (callback: ScrollingCallback, deps?: any[]) => {
    const list = useContext(ScrollingContext);
    useEffect(() => {
        list.push(callback);
        return () => void (Arr.remove(list, callback));
    }, deps ?? []);
};

export const Scroller: LFC<{ onScroll?: ScrollingCallback }> = ({ children, onScroll }) => {

    const list = useRef<ScrollingCallback[]>([]);

    const onScrollFrame = useCallback((data: positionValues) => {
        if (onScroll) onScroll(data);
        list.current.forEach(x => x(data));
    }, [onScroll, list]);

    return <ScrollingContext.Provider value={list.current}>
        <XScrollbars className="scrollbars" autoHide onScrollFrame={onScrollFrame}>
            {children}
        </XScrollbars>
    </ScrollingContext.Provider>;

};
